import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CabeceracorporativoModule } from "../../../components/common/cabeceracorporativo/cabeceracorporativo.module";
import { SeguroscorporativosContratados } from "./seguros-contratadoscorporativo.component";
import { SegurosContratadoscorporativoService } from "./seguros-contratadoscorporativo.service";
import { UtilService } from "../../../components/common/utils/util.service"
import { DataTableModule } from "angular2-datatable";
import { DatosGeneralesService } from "../datosGenerales/datos-generales.service";
import { ConsultarUsuarioMasivos } from "../../../components/common/utils/consultarUsuarioMasivos";
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { Ng2Webstorage } from "ngx-webstorage";
import { CalendarModule } from 'primeng/primeng';
import { SiniestrosModule } from "../../siniestros/siniestros.model";
import { ApplicationPipesModule } from "../../../components/pipes/safe.module";

@NgModule({
    declarations: [SeguroscorporativosContratados],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        CabeceracorporativoModule,
        DataTableModule,
        Ng2Bs3ModalModule,
        Ng2Webstorage,
        CalendarModule,
        SiniestrosModule,
        ApplicationPipesModule
    ],
    providers: [SeguroscorporativosContratados, UtilService, DatosGeneralesService, ConsultarUsuarioMasivos]
})

export class SegurosContratadoscorporativoModule { }



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/vehiculoscorporativos/seguros-contratadoscorporativo.module.ts